module.exports = __webpack_public_path__ + "img/img15.e880a102.svg";